// pages/NotificationDetails.jsx
import React, { useEffect } from 'react';
import {
  Box,
  Typography,
  Paper,
  Chip,
  Divider,
  Button,
  Card,
  CardContent,
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const NotificationDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { notificationData, originalNotification } = location.state || {};

  console.log('📄 NotificationDetails page loaded:', {
    locationState: location.state,
    notificationData,
    originalNotification
  });

  useEffect(() => {
    console.log('🔍 NotificationDetails useEffect - checking data availability');
    if (!notificationData) {
      console.warn('⚠️ No notification data found in location state');
    } else {
      console.log('✅ Notification data available:', notificationData);
    }
  }, [notificationData]);

  if (!notificationData) {
    console.log('❌ Rendering error state - no notification data');
    return (
      <Box sx={{ p: 3 }}>
        <Typography variant="h6">Notification not found</Typography>
        <Button 
          onClick={() => navigate(-1)} 
          sx={{ mt: 2 }}
        >
          Go Back
        </Button>
      </Box>
    );
  }

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString();
  };

  console.log('🎨 Rendering NotificationDetails with data');

  return (
    <Box sx={{ p: 3, maxWidth: 800, margin: '0 auto', mt: 8 }}>
      {/* Back Button */}
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={() => {
          console.log('🔙 Back button clicked');
          navigate(-1);
        }}
        sx={{ mb: 3 }}
      >
        Back
      </Button>

      {/* Original Message */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Notification Message
          </Typography>
          <Typography variant="body1" sx={{ fontStyle: 'italic' }}>
            "{originalNotification?.message}"
          </Typography>
        </CardContent>
      </Card>

      {/* Notification Details */}
      <Paper sx={{ p: 3 }}>
        <Typography variant="h5" gutterBottom>
          Notification Details
        </Typography>
        
        <Divider sx={{ mb: 3 }} />

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="subtitle1" fontWeight="bold">Activity ID:</Typography>
            <Typography variant="body1">#{notificationData.log_id}</Typography>
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="subtitle1" fontWeight="bold">Activity Type:</Typography>
            <Chip 
              label={notificationData.activity_type} 
              color="primary" 
              variant="outlined"
            />
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="subtitle1" fontWeight="bold">Activity As:</Typography>
            <Chip 
              label={notificationData.activity_as} 
              color="secondary" 
              variant="outlined"
            />
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="subtitle1" fontWeight="bold">Status:</Typography>
            <Chip 
              label={notificationData.status ? 'Active' : 'Inactive'} 
              color={notificationData.status ? 'success' : 'default'}
            />
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="subtitle1" fontWeight="bold">Property ID:</Typography>
            <Typography variant="body1">#{notificationData.property_id}</Typography>
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="subtitle1" fontWeight="bold">User ID:</Typography>
            <Typography variant="body1">#{notificationData.user_id}</Typography>
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="subtitle1" fontWeight="bold">Property By:</Typography>
            <Typography variant="body1">#{notificationData.property_by}</Typography>
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="subtitle1" fontWeight="bold">Created At:</Typography>
            <Typography variant="body2">
              {formatDate(notificationData.created_at)}
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="subtitle1" fontWeight="bold">Updated At:</Typography>
            <Typography variant="body2">
              {formatDate(notificationData.updated_at)}
            </Typography>
          </Box>
        </Box>

        {/* Action Buttons */}
        <Box sx={{ mt: 4, display: 'flex', gap: 2 }}>
          <Button 
            variant="contained" 
            color="primary"
            onClick={() => {
              console.log('🏠 View Property clicked:', notificationData.property_id);
              // Navigate to property page or perform other action
            }}
          >
            View Property
          </Button>
          <Button 
            variant="outlined"
            onClick={() => {
              console.log('👤 View User Profile clicked:', notificationData.user_id);
              // Navigate to user profile or perform other action
            }}
          >
            View User Profile
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default NotificationDetails;